import { TextField } from "../../../../utils/form";

const Surname = ({ form: { control } }) =>
  <TextField control={control} name="surname" label="Apellido" variant="outlined" required style={{ width: "100%" }} />

export default Surname;